import t from 'react-translate';
import { useContext } from 'react';
import useClearUrlParams from 'athena/hooks/use-clear-url-params';
import MentoringProgramContext from 'athena/components/mentoring-program/context';
import { Button } from 'react-bootstrap';
import { config } from '@config/pendo.config.json';

const MentorRequestContinueBrowsingButton = () => {
  const { mentoringProgram } = useContext(MentoringProgramContext);
  const { setShowFindMentorModal } = mentoringProgram;
  const removeParams = useClearUrlParams(['mentorRequest', 'source']);

  const handleClick = () => {
    setShowFindMentorModal(true);
    removeParams();
  };

  const dataQATag = config.pendo.athena.mentorshipProgram.participantHome.mentorRequest.modal.mentee.continueBrowsingButton;

  return (
    <Button
      size='lg'
      onClick={handleClick}
      data-qa={dataQATag}
    >
      {t.MENTORING_PROGRAMS.PARTICIPANT_HOME.MENTOR_REQUEST_MODAL.MENTEE_VIEW.CONTINUE_BROWSING()}
    </Button>
  );
};

export default MentorRequestContinueBrowsingButton;
